// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 353 ? "reactPlayerPreview" : chunkId) + "." + {"96":"a962562d","270":"38642040","353":"0dc44d81","494":"dc5e0227","744":"a90671e3","850":"ba83e469","925":"26007137"}[chunkId] + ".chunk.js";
};